import { useState, useCallback, useEffect } from 'react';
import i18next from 'i18next';
import { useLanguageContext } from '../context/LanguageContext';

export default function useLanguage() {
  const [isLanguageMenu, setIsLanguageMenu] = useState(false);
  const [language, setLanguage] = useState({});

  const { languages } = useLanguageContext();
  const setCurrentLanguage = useCallback(() => {
    let language = null;
    languages.map(item => {
      if (i18next.language.includes(item.lng)) {
        language = item;
      }
    });
    if (!language) {
      language = languages.find(item => item.name === 'English');
    }
    setLanguage(language);
  }, []);

  useEffect(() => {
    setCurrentLanguage();
  }, []);

  return {
    isLanguageMenu,
    setIsLanguageMenu,
    language,
    setLanguage,
    languages,
    setCurrentLanguage,
  };
}
